/**
 * 项目状态保存
 * @author luwei
 * @version 1.0.0, 2019-03-16
 */
import Vue from "vue";
import Vuex from "vuex";
import { post } from "./util/http";
import _, { method } from "lodash";
import { bizConstantRouter, bizAsyncRouter } from "./bizConfig";
Vue.use(Vuex);
/**
 * 构造菜单树
 * @param {object} parentNode 父菜单节点
 * @param {menus[]} allMenus 菜单数组
 */
const makeTree = (parentNode, allMenus) => {
  const children = _.filter(allMenus, o => {
    if (
      (_.isNil(o.parentId) ||
        o.parentId === "null" ||
        o.parentId === "" ||
        o.parentId === "0") &&
      parentNode.id === 1
    ) {
      return true;
    }
    return o.parentId === parentNode.id;
  });
  _.forEach(children, function(child) {
    const node = {
      ...child,
      visible: child.menuType === -1 ? false : true,
      children: []
    };
    parentNode.children.push(node);
    makeTree(node, allMenus);
  });
};

const makeTree2 = (root, allMenus) => {
  if (!allMenus || allMenus.length == 0) {
    return root;
  }
  if (!root) {
    root = {};
    var children = [];
    for (var i = 0; i < allMenus.length; i++) {
      var menu = allMenus[i];
      if (!menu.parentId || menu.parentId === "0") {
        children.push(menu);
      }
    }
    for (var i = 0; i < children.length; i++) {
      children[i] = makeTree2(children[i], allMenus);
    }
    root.children = children;
  } else {
    var children = [];
    for (var i = 0; i < allMenus.length; i++) {
      var menu = allMenus[i];
      // var subChildren = makeTree2(menu, allMenus);
      if (menu.parentId === root.id) {
        children.push(menu);
      }
    }
    if (children.length > 0) {
      for (var i = 0; i < children.length; i++) {
        children[i] = makeTree2(children[i], allMenus);
      }
    }
    root.children = children;
  }
  return root;
};

/**
 * 状态存储
 */
const store = new Vuex.Store({
  state: {
    ccz:0,
    indexKeyWord: "",
    navigationList: [],
    breadCrumbList:[],
    //左侧悬浮操作栏
    suspensionList:[
      {
        name:"home",
        title:"首页",
        isshow:true,
        icon:"home",
        activeIcon:"",
        isactive:false,
        event:()=>{}
      },
      {
        name:"retprest",
        title:"返回",
        isshow:false,
        icon:"fanhui",
        activeIcon:"",
        isactive:false,
        event:()=>{}
      }
    ],
    //澳门出访天数
    applayADay: 0,
    //香港出访天数
    applayXDay: 0,
    //逾期本数（）
    total: {},
    //团组次数类型
    timesType: "",
    // 全局遮罩层显示与隐藏
    coverShow: false,
    token: null,
    /** 赋权菜单列表 */
    menus: [],
    /** 赋权菜单树 */
    menuTree: [],
    /**修改菜单小图标 */
    iconList: [
      "icon-yemian-copy",
      "icon-yemian-copy",
      "icon-shangchuananli",
      "icon-niandujihuaguanli",
      "icon-guanlijihuashenbao-",
      "icon-jihuatiaozheng",
      "icon-shenbao",
      "icon-shenpi",
      "icon-chaxuntongji",
      "icon-moni",
      "icon-yonghu",
      "icon-shenpiguanli",
      "icon-wenjianxitongguanli",
      "icon-jichuguanli",
      "icon-fuwugongnengguanli",
      "icon-liucheng"
    ],
    /** 赋权API标签(apiTag)列表 */
    apis: [],
    loading: false,
    // 选择日期范围
    dateRangePickerOptions: {
      shortcuts: [
        {
          text: "最近一周",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: "最近一个月",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: "最近三个月",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }
      ]
    },
    // 选择日期
    datePickerOptions: {
      shortcuts: [
        {
          text: "今天",
          onClick(picker) {
            picker.$emit("pick", new Date());
          }
        },
        {
          text: "昨天",
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", date);
          }
        },
        {
          text: "一周前",
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", date);
          }
        }
      ]
    },
    // 分页控件的每页显示条目个数
    paginationPageSizes: [10, 20, 50, 100],
    // 分页控件组件布局，子组件名用逗号分隔
    paginationLayout: "total, sizes, prev, pager, next, jumper",
  },
  /**
 * 状态存储
 */
  getters:{
    isApply(){
      return document.getElementById('layoutApply') !== null
    }
  },
  /**
   * 同步更新操作
   */
  mutations: {
    addccz(state,newState){
      state.ccz++
    },
    editsuspensionList(state,newState){
     state.suspensionList.forEach(item=>{
      newState.forEach(ite=>{
        if(item.name==ite.name){
          Object.assign(item,ite)
        }
      })
     })
    },
    showSusPension(state,newState){
      newState.push("home")
      state.suspensionList.forEach(item=>item.isshow=newState.includes(item.name))
    },
    addSusPension(state,newState){
      state.suspensionList.splice(1, 0, ...newState)
    },
    reduction(state,newState){
      state.suspensionList=[
        {
          name:"home",
          title:"首页",
          isshow:true,
          icon:"home",
          activeIcon:"",
          isactive:false,
          event:()=>{}
        },
        {
          name:"retprest",
          title:"返回",
          isshow:false,
          icon:"fanhui",
          activeIcon:"",
          isactive:false,
          event:()=>{}
        }
      ]
    },
    resizeNav(state,newState){
      state.breadCrumbList = newState
    },
    pushNav(state,newState){
      state.breadCrumbList.push(newState)
    },
    clearNav(state,newState){
      state.breadCrumbList.splice(0, state.breadCrumbList.length)
    },
    // 添加导航
    addNavigation(state, navigationInfo) {
      state.navigationList.push(navigationInfo);
    },
    // 删除导航
    deleteNavigation(state) {
      state.navigationList.pop();
    },
    //保存香港出访天数
    geApplayADay(state, newState) {
      state.applayADay = newState;
    },
    //保存香港出访天数
    geApplayXDay(state, newState) {
      state.applayXDay = newState;
    },
    //获取逾期本书
    getTotal2(state, newState) {
      state.total = newState;
    },
    //获取团组次数类型
    changeTimesType(state, newState) {
      state.timesType = newState;
    },
    //获取当前菜单
    getCurrentMenu(state, newName) {
      state.menuName = newName;
    },
    //是否显示遮罩层
    changeShow(state, newState) {
      state.coverShow = newState;
    },
    /** 存储会话token */
    setToken(state, newToken) {
      state.token = newToken;
    },
    /** 存储赋权菜单列表 */
    setMenus(state, menus) {
      state.menus = menus;
    },
    /** 存储赋权菜单树 */
    setMenuTree(state, menuTree) {
      state.menuTree = menuTree;
    },
    /** 存储赋权API标签(apiTag)列表 */
    setApis(state, apis) {
      state.apis = apis;
    },
    setAsyncRouter(state, data) {
      state.asyncRouterData = data;
    }
  },
  /**
   * 异步更新操作
   */
  actions: {
    /**
     * 重新从服务器读取用户权限信息
     * @param {*} context store上下文
     */
    reloadUserAuthority(context) {
      return post("/sum/sumMenu/selectByLoginUser").then(result => {
        let router = [];
        const menus = result.data.menus;
        _.forEach(menus, function(menu) {
          // 确保menuUri不能为空, 因为父菜单menuUri为空，导致构造菜单树报错
          if (!menu.menuUri) {
            menu.menuUri = menu.id;
          }
          menu.path = menu.menuUri;
        });
        const rootMenuNode = {
          id: 1,
          children: []
        };
        makeTree(rootMenuNode, menus);
        const rootMenuNode2 = {
          id: 1,
          children: []
        };
        let root = makeTree2(null, menus);
        context.commit("setAsyncRouter", JSON.stringify(root.children));
        context.commit("setMenus", _.concat(rootMenuNode, menus));
        context.commit("setMenuTree", rootMenuNode.children);
        context.commit("setApis", result.data.apis);
      });
    },
    /**
     * 用户登出时的清理
     * @param {*} context store上下文
     */
    signOut(context) {
      context.commit("setToken", null);
      context.commit("setMenus", []);
      context.commit("setApis", []);
    }
  }
});

export default store;
